import React from 'react';
import { Auth } from 'aws-amplify';
import { GoogleIcon, FacebookIcon } from './data';
import * as S from './styles';

function FederationContainer() {
    const onGoogleClick = (e) => {
        e.preventDefault();
        Auth.federatedSignIn({ provider: 'Google' });
    };

    const onFacebookClick = (e) => {
        e.preventDefault();
        Auth.federatedSignIn({ provider: 'Facebook' });
    };

    return (
        <S.Form>
            <S.InnerTitle>Sign In with your social account</S.InnerTitle>
            <S.SocialWrap>
                <S.GoogleButton onClick={onGoogleClick}>
                    <span>{GoogleIcon}</span>
                    <span>Continue with Google</span>
                </S.GoogleButton>
                <S.FacebookButton onClick={onFacebookClick}>
                    <span>{FacebookIcon}</span>
                    <span>Continue with Facebook</span>
                </S.FacebookButton>
                <S.SmallText>
                    This does not give us the ability to automatically post content
                </S.SmallText>
            </S.SocialWrap>
        </S.Form>
    );
}

export default FederationContainer;
export { FederationContainer };
